import React, { useEffect } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';

import axios from 'axios';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SetupGuard from './SetupGuard';
import AdminLayout from './admin/AdminLayout';
import { ModuleLayout } from './ui';
import Dashboard from './admin/components/Dashboard';
import ResturantDashbord from './admin/components/ResturantDashbord';
import DashboardSwitcher from './admin/components/DashboardSwitcher';
import HotelList from './admin/components/HotelList';
import AddHotel from './admin/components/AddHotel';
import RoomList from './admin/components/RoomList';
import AddRoom from './admin/components/AddRoom';
import ManageInventory from './admin/components/ManageInventory';
import ManagePackage from './admin/components/ManagePackage';
import RoomTypeMaster from './admin/components/RoomTypeMaster';
import AddBanquetHall from './admin/components/AddBanquetHall';
import Availbleroom from './admin/components/RoomAvailable';
import BookingReport from './admin/components/Bookings';
import PackageReport from './admin/components/PackageReport';
import InvoicePage from './admin/components/InvoicePage';
import Login from './admin/Login';
import DirectLogin from './admin/DirectLogin';
import Logout from './admin/components/Logout';
import PettyCashManagement from './admin/components/PettyCashManagement';
import Addonm from './admin/components/Addonmaster';
import Paymentreport from './admin/components/PaymentLedgerReport';
import RestaurantPayments from './admin/components/RestaurantPayments';
import IndentEntry from './admin/components/IndentEntry';
import IndentList from './admin/components/IndentList';
import AmountCorrection from './admin/components/AmountCorrection';
import Bookingfilter from './admin/components/BookingReportPage';
import AddonProfitReport from './admin/components/Addonprofit';
import InvoiceReport from './admin/components/InvoiceReport';
import NightAuditReport from './admin/components/NightAuditReport';
import GstReports from './admin/components/GstReports';
import ActivityLogReport from './admin/components/ActivityLogReport';
import HrDepartments from './admin/components/Hr/Departments';
import HrDesignations from './admin/components/Hr/Designations';
import HrEmployees from './admin/components/Hr/Employees';
import HrShifts from './admin/components/Hr/Shifts';
import HrAttendance from './admin/components/Hr/Attendance';
import HrLeaveTypes from './admin/components/Hr/LeaveTypes';
import HrLeaveRequests from './admin/components/Hr/LeaveRequests';
import HrOvertime from './admin/components/Hr/Overtime';
import HrAdvanceSalary from './admin/components/Hr/AdvanceSalary';
import HrLoans from './admin/components/Hr/Loans';
import HrSalaryStructure from './admin/components/Hr/SalaryStructure';
import HrPayroll from './admin/components/Hr/Payroll';
import HrPayslip from './admin/components/Hr/Payslip';
import HrSalaryPayments from './admin/components/Hr/SalaryPayments';
import HrServiceCharge from './admin/components/Hr/ServiceCharge';
import HrTips from './admin/components/Hr/Tips';
import HrStaffMeals from './admin/components/Hr/StaffMeals';
import HrUniformDeposit from './admin/components/Hr/UniformDeposit';
import HrDashboard from './admin/components/Hr/HrDashboard';
import HrReports from './admin/components/Hr/HrReports';
import Guestreport from './admin/components/Guestreport';
import CreateUser from './admin/components/CreateUser';
import UserPermission from './admin/components/UserPermission';
import UserReport from './admin/components/UserReport';
import RestaurantInvoiceReport from './admin/components/RestaurantInvoiceReport';
import RestaurantActivity from './admin/components/RestaurantActivity';
import MenuUploadHistory from './admin/components/MenuUploadHistory';
import MultiHotelDashboard from './admin/components/MultiHotelDashboard';
import StockTransfer from './admin/components/StockTransfer';
import StockOpeningClosingReport from './admin/components/StockOpeningClosingReport';
import OrderHistory from './admin/components/OrderHistory';
import BookingHistory from './admin/components/BookingHistory';
import RestaurantGuestReport from './admin/components/RestaurantGuestReport';
import SuperAdminCompanies from './admin/components/SuperAdminCompanies';
import QuickBooking from './admin/components/QuickBooking';
import Reservations from './admin/components/Reservations';
import MenuMaster from './admin/components/MenuMaster';
import SupportTickets from './admin/components/SupportTickets';
import SupportAdmin from './admin/components/SupportAdmin';
import RbacRoleManagement from './admin/components/RbacRoleManagement';
import RbacUserOverrides from './admin/components/RbacUserOverrides';
import Agent from './admin/components/Agent';
import AgentReport from './admin/components/AgentReport';
import AgentCommision from './admin/components/AgentCommision';
import Couponmaster from './admin/components/Couponmaster';
import Addonreport from './admin/components/Addonreport';
import RoomBookingWizard from './admin/components/RoomBookingWizard';
import BulkBookings from './admin/components/bulkbookings';
import PurchaseEntry from './admin/components/PurchaseEntry';
import PurchaseLedgerReport from './admin/components/PurchaseLedgerReport';
import StorePurchase from './admin/components/StorePurchase';
import RecipeMaster from './admin/components/RecipeMaster';
import SupplierMaster from './admin/components/SupplierMaster';
import ChannelManager from './admin/components/ChannelManager';
import StockDashboard from './admin/components/StockDashboard';
import PurchaseReports from './admin/components/PurchaseReports';
import HoldRoom from './admin/components/HoldRoom';
import config from './config';
import Holdreport from './admin/components/Holdreport';
import Category from './admin/components/Category';
import AddItem from './admin/components/AddItem';
import CreateOrder from './admin/components/CreateOrder';
import AreaPricing from './admin/components/AreaPricing';
import KotReport from './admin/components/KotReport';
import HourlyBooking from './admin/components/HourlyBooking';
import Order from './admin/components/Order';
import RestroInvoice from './admin/components/RestroInvoice';
import Changeroom from './admin/components/Changeroom';
import Calender from './admin/components/Calender';
import ItemReport from './admin/components/ItemReport';
import ExpiryReport from './admin/components/ExpiryReport';
import AllCategory from './admin/components/AllCategory';
import Createarea from './admin/components/Createarea';
import TableOrders from './admin/components/TableOrders';
import QrCodeGenerator from './admin/components/QrCodeGenerator';
import BookingLedger from './admin/components/BookingLedger';
import AddDepartment from './admin/components/AddDepartment';
import QrPageLoader from './admin/QrPageLoader';
import HotelSetupWizard from './admin/components/HotelSetupWizard';
import HotelSetupWizardIndia from './admin/components/HotelSetupWizardIndia';
import Customerwallet from './admin/components/Customerwallet';
import ChangePackage from './admin/components/ChangePackage';
import KitchenPendingOrders from './admin/components/KitchenPendingOrders';
import VariantManagement from './admin/components/VariantManagement';
import ItemStoreMapping from './admin/components/ItemStoreMapping';
import StoreMaster from './admin/components/StoreMaster';
import RestaurantMastersLayout from './admin/components/RestaurantMastersLayout';
import RestaurantOrdersLayout from './admin/components/RestaurantOrdersLayout';
import StockTransactionHistory from './admin/components/StockTransactionHistory';
// ---- New modules: Spa / Laundry / MiniBar / Housekeeping ----
import SpaServiceMaster from './admin/components/SpaServiceMaster';
import TherapistMaster from './admin/components/TherapistMaster';
import SpaBookings from './admin/components/SpaBookings';
import LaundryItemMaster from './admin/components/LaundryItemMaster';
import LaundryOrders from './admin/components/LaundryOrders';
import MiniBarItemMaster from './admin/components/MiniBarItemMaster';
import MiniBarConsumption from './admin/components/MiniBarConsumption';
import HousekeepingStaffMaster from './admin/components/HousekeepingStaffMaster';
import HousekeepingTasks from './admin/components/HousekeepingTasks';
import HousekeepingDashboard from './admin/components/HousekeepingDashboard';
import Agentcommissionreport from './admin/components/Agentcommissionreport';
// ---- SaaS Subscription module ----
import Subscription from './admin/components/Subscription';
import SubscriptionPlans from './admin/components/SubscriptionPlans';
import SubscriptionPaymentReport from './admin/components/SubscriptionPaymentReport';
// ------------------ Protected Route ------------------
// Setup-check is handled in Login.js (API-based).
// ProtectedRoute only guards against unauthenticated access.
function ProtectedRoute({ children, skipSetupCheck = false }) {
  const user = sessionStorage.getItem('user');
  if (!user) return <Navigate to='/login' replace />;

  // Fallback: if somehow an unauthenticated user reaches admin without a
  // hotel (e.g. direct URL), send them to setup.
  if (!skipSetupCheck && !localStorage.getItem('hotelSetupDone')) {
    return <Navigate to='/setup' replace />;
  }
  return children;
}

export default function App() {
  const navigate = useNavigate();

  return (
    <>
      <ToastContainer position='top-right' autoClose={3000} theme='light' />

      <Routes>
        <Route
          path='/'
          element={
            <ProtectedRoute>
              <Navigate to='/admin' replace />
            </ProtectedRoute>
          }
        />

        <Route path='/login' element={<Login />} />
        <Route path='/direct-login' element={<DirectLogin />} />
        <Route path='/logout' element={<Logout />} />

        {/* Hotel Setup Wizard — international */}
        <Route
          path='/setup'
          element={
            <ProtectedRoute skipSetupCheck={true}>
              <SetupGuard>
                <HotelSetupWizard />
              </SetupGuard>
            </ProtectedRoute>
          }
        />

        <Route
          path='/setup/india'
          element={
            <ProtectedRoute skipSetupCheck={true}>
              <SetupGuard>
                <HotelSetupWizardIndia />
              </SetupGuard>
            </ProtectedRoute>
          }
        />

        <Route path='/invoice/:bookingId' element={<InvoicePage />} />

        <Route path='/RestroInvoice/:orderId' element={<RestroInvoice />} />
        <Route path='/order' element={<QrPageLoader />} />
        <Route
          path='/admin/*'
          element={
            <ProtectedRoute>
              <AdminLayout />
            </ProtectedRoute>
          }>
          {/* <Route index element={<Dashboard />} /> */}
          <Route index element={<DashboardSwitcher />} />
          <Route path='dashboard' element={<DashboardSwitcher />} />

          {/* Front Desk module - compact header + horizontal tabs. Paths UNCHANGED. */}
          <Route element={<ModuleLayout moduleKey='frontdesk' />}>
            <Route path='BookingReport' element={<BookingReport />} />
            <Route path='Bookingfilter' element={<Bookingfilter />} />
            <Route path='Calender' element={<Calender />} />
            <Route path='Changeroom' element={<Changeroom />} />
            <Route path='HoldRoom' element={<HoldRoom />} />
            <Route path='BulkBookings' element={<BulkBookings />} />
          </Route>
          <Route path='SuperAdminCompanies' element={<SuperAdminCompanies />} />
          <Route path='QuickBooking' element={<QuickBooking />} />
          <Route path='Reservations' element={<Reservations />} />
          <Route path='MenuMaster' element={<MenuMaster />} />
          <Route path='SupportTickets' element={<SupportTickets />} />
          <Route path='SupportAdmin' element={<SupportAdmin />} />
          <Route path='resturantdashbord' element={<ResturantDashbord />} />
          <Route path='hotels' element={<HotelList />} />
          <Route path='hotels/add' element={<AddHotel />} />
          <Route path='rooms' element={<RoomList />} />
          <Route path='rooms/add' element={<AddRoom />} />
          <Route path='roomtype' element={<RoomTypeMaster />} />
          <Route path='manageinventory' element={<ManageInventory />} />
          <Route path='managepackage' element={<ManagePackage />} />
          <Route path='banquethall/add' element={<AddBanquetHall />} />
          <Route path='availableroom' element={<Availbleroom />} />
          <Route path='packagereport' element={<PackageReport />} />
          <Route path='PettyCashManagement' element={<PettyCashManagement />} />
          <Route path='Addonm' element={<Addonm />} />
          <Route path='Paymentreport' element={<Paymentreport />} />
          <Route path='IndentEntry' element={<IndentEntry />} />
          <Route path='IndentList' element={<IndentList />} />
          <Route path='AmountCorrection' element={<AmountCorrection />} />
          <Route path='AddonProfitReport' element={<AddonProfitReport />} />
          <Route path='InvoiceReport' element={<InvoiceReport />} />
          <Route path='NightAuditReport' element={<NightAuditReport />} />
          <Route path='GstReports' element={<GstReports />} />
          <Route path='ActivityLog' element={<ActivityLogReport />} />
          <Route path='Hr/Departments' element={<HrDepartments />} />
          <Route path='Hr/Designations' element={<HrDesignations />} />
          <Route path='Hr/Employees' element={<HrEmployees />} />
          <Route path='Hr/Shifts' element={<HrShifts />} />
          <Route path='Hr/Attendance' element={<HrAttendance />} />
          <Route path='Hr/LeaveTypes' element={<HrLeaveTypes />} />
          <Route path='Hr/LeaveRequests' element={<HrLeaveRequests />} />
          <Route path='Hr/Overtime' element={<HrOvertime />} />
          <Route path='Hr/AdvanceSalary' element={<HrAdvanceSalary />} />
          <Route path='Hr/Loans' element={<HrLoans />} />
          <Route path='Hr/SalaryStructure' element={<HrSalaryStructure />} />
          <Route path='Hr/Payroll' element={<HrPayroll />} />
          <Route path='Hr/Payslip/:payrollId' element={<HrPayslip />} />
          <Route path='Hr/SalaryPayments' element={<HrSalaryPayments />} />
          <Route path='Hr/ServiceCharge' element={<HrServiceCharge />} />
          <Route path='Hr/Tips' element={<HrTips />} />
          <Route path='Hr/StaffMeals' element={<HrStaffMeals />} />
          <Route path='Hr/UniformDeposit' element={<HrUniformDeposit />} />
          <Route path='Hr/Dashboard' element={<HrDashboard />} />
          <Route path='Hr/Reports' element={<HrReports />} />
          <Route path='Guestreport' element={<Guestreport />} />
          <Route path='CreateUser' element={<CreateUser />} />
          <Route path='UserPermission' element={<UserPermission />} />
          <Route path='UserReport' element={<UserReport />} />
          <Route
            path='RestaurantInvoiceReport'
            element={<RestaurantInvoiceReport />}
          />
          <Route path='RestaurantActivity' element={<RestaurantActivity />} />
          <Route path='MultiHotelDashboard' element={<MultiHotelDashboard />} />
          <Route path='StockTransfer' element={<StockTransfer />} />
          <Route path='StockOpeningClosingReport' element={<StockOpeningClosingReport />} />
          <Route path='BookingHistory' element={<BookingHistory />} />
          <Route
            path='RestaurantGuestReport'
            element={<RestaurantGuestReport />}
          />
          <Route path='RbacRoles' element={<RbacRoleManagement />} />
          <Route path='RbacUserOverrides' element={<RbacUserOverrides />} />
          <Route path='Agent' element={<Agent />} />
          <Route path='AgentReport' element={<AgentReport />} />
          <Route path='AgentCommision' element={<AgentCommision />} />
          <Route path='Couponmaster' element={<Couponmaster />} />
          <Route path='Addonreport' element={<Addonreport />} />
          <Route path='RoomBookingWizard' element={<RoomBookingWizard />} />
          <Route path='PurchaseEntry' element={<PurchaseEntry />} />
          <Route
            path='PurchaseLedgerReport'
            element={<PurchaseLedgerReport />}
          />
          <Route path='StorePurchase' element={<StorePurchase />} />
          <Route path='RecipeMaster' element={<RecipeMaster />} />
          <Route path='SupplierMaster' element={<SupplierMaster />} />
          <Route path='ChannelManager' element={<ChannelManager />} />
          <Route path='StockDashboard' element={<StockDashboard />} />
          <Route path='PurchaseReports' element={<PurchaseReports />} />
          <Route path='Holdreport' element={<Holdreport />} />
          {/* ---- Restaurant Masters workspace ----------------------------
               Pathless layout route: adds the horizontal tab strip over the
               nine master pages. Paths, components, permissions unchanged. */}
          <Route element={<RestaurantMastersLayout />}>
            <Route path='AddDepartment' element={<AddDepartment />} />
            <Route path='Createarea' element={<Createarea />} />
            <Route path='Category' element={<Category />} />
            <Route path='AddItem' element={<AddItem />} />
            <Route path='VariantManagement' element={<VariantManagement />} />
            <Route path='StoreMaster' element={<StoreMaster />} />
            <Route path='ItemStoreMapping' element={<ItemStoreMapping />} />
            <Route path='AreaPricing' element={<AreaPricing />} />
            <Route path='MenuUploadHistory' element={<MenuUploadHistory />} />
          </Route>
          {/* ---- Restaurant Orders workspace ----------------------------
               Pathless layout route: horizontal tab strip over the ordering
               pages. Paths, components, permissions unchanged. */}
          <Route element={<RestaurantOrdersLayout />}>
            <Route path='CreateOrder' element={<CreateOrder />} />
            <Route path='QuickBill' element={<CreateOrder quickBill />} />
            <Route path='Order' element={<Order />} />
            <Route path='TableOrders' element={<TableOrders />} />
            <Route path='RestaurantPayments' element={<RestaurantPayments />} />
            <Route path='OrderHistory' element={<OrderHistory />} />
          </Route>
          <Route path='KotReport' element={<KotReport />} />
          <Route path='HourlyBooking' element={<HourlyBooking />} />
          <Route path='ItemReport' element={<ItemReport />} />
          <Route path='ExpiryReport' element={<ExpiryReport />} />
          <Route path='AllCategory' element={<AllCategory />} />
          <Route path='QrCodeGenerator' element={<QrCodeGenerator />} />
          <Route path='BookingLedger' element={<BookingLedger />} />
          <Route path='Customerwallet' element={<Customerwallet />} />
          <Route path='ChangePackage' element={<ChangePackage />} />
          <Route
            path='Agentcommissionreport'
            element={<Agentcommissionreport />}
          />
          <Route
            path='KitchenPendingOrders'
            element={<KitchenPendingOrders />}
          />
          <Route
            path='StockTransactionHistory'
            element={<StockTransactionHistory />}
          />

          {/* ---- Spa POS ---- */}
          <Route path='Spa/Services' element={<SpaServiceMaster />} />
          <Route path='Spa/Therapists' element={<TherapistMaster />} />
          <Route path='Spa/Bookings' element={<SpaBookings />} />

          {/* ---- Laundry POS ---- */}
          <Route path='Laundry/Items' element={<LaundryItemMaster />} />
          <Route path='Laundry/Orders' element={<LaundryOrders />} />

          {/* ---- Mini-Bar POS ---- */}
          <Route path='MiniBar/Items' element={<MiniBarItemMaster />} />
          <Route path='MiniBar/Consumption' element={<MiniBarConsumption />} />

          {/* ---- Housekeeping ---- */}
          <Route
            path='Housekeeping/Dashboard'
            element={<HousekeepingDashboard />}
          />
          <Route
            path='Housekeeping/Staff'
            element={<HousekeepingStaffMaster />}
          />
          <Route path='Housekeeping/Tasks' element={<HousekeepingTasks />} />

          {/* ---- SaaS Subscription ---- */}
          <Route path='Subscription' element={<Subscription />} />
          <Route path='SubscriptionPlans' element={<SubscriptionPlans />} />
          <Route
            path='SubscriptionPaymentReport'
            element={<SubscriptionPaymentReport />}
          />
        </Route>

        <Route
          path='*'
          element={
            <div style={{ padding: '2rem' }}>
              <h1>Page Not Found</h1>
            </div>
          }
        />
      </Routes>
    </>
  );
}
